<template>
    <div>
      <orders-superior-menu></orders-superior-menu>
      <div>
        <ArticleList origin="1"></ArticleList>
      </div>
    </div>
  </template>
  
  <script>
  import ArticleList from "@/components/utils/ArticleList.vue";
  import OrdersSuperiorMenu from "@/components/layout/OrdersSuperiorMenu.vue";
  
  export default {
    components: { ArticleList, OrdersSuperiorMenu },
  };
  </script>